/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useEffect} from "react";
import PackageDetail from "pages/Front/Booking/components/PackageDetail/PackageDetail";
import {useTypedSelector} from "helpers/reducers";
import {RouteComponentProps, useLocation, withRouter} from "react-router-dom";
import {useDispatch} from "useDispatch";
import Loader from "components/Loader";
import {isGiftCard, isThreeTwo, isYearly} from "utils/packageUtils";
import GiftCardPackageDetail from "pages/Front/Booking/components/GiftCardPackage/GiftcardPackageDetail";
import {Package} from "types/entities/Package";
import {getVoucherCodes} from "utils/voucherUtils";
import {SELL_GIFTCARD_VOUCHERS} from "helpers/config";
import GiftCardPackageDetailNew from "pages/Front/Booking/components/GiftCardPackage/GiftCardPackageDetailNew";
import YearlyPackageDetail from "pages/Front/Booking/components/YearlyPackage/YearlyPackageDetail";
import ThreeTwoPackageDetail from "pages/Front/Booking/components/YearlyPackage/ThreeTwoPackageDetail";
import BookingAction from "store/booking/BookingAction";
import Dates from "utils/Dates";
import {PackageCategory} from "types/enums/PackageCategory";

interface Params {
    package_id: string;
    package_name?: string;
}

interface Props extends RouteComponentProps<Params> {}

const BookingPackage = (props: Props) => {
    const packages = useTypedSelector(state => state.bookingState.packages);
    const filter = useTypedSelector(state => state.bookingState.bookingProcess.filter);
    const dateChosenByCustomer = useTypedSelector(state => state.bookingState.bookingProcess.dateChosenByCustomer);
    const location = useLocation();
    const dispatch = useDispatch();
    const voucherItems = useTypedSelector(state => state.voucherState.voucherItems);

    useEffect(() => {
        const voucherCodes = getVoucherCodes(voucherItems);
        // dispatch(BookingAction.fetchPackagesByLocationParams(location, filter, dateChosenByCustomer, voucherCodes));
    }, [voucherItems]);

    const foundPackage: Package | null | undefined = packages
        ? Object.values(packages).find(packageDetail => {
              if (Number.isInteger(+props.match.params.package_id)) {
                  return packageDetail.id === +props.match.params.package_id;
              }
              return packageDetail.rewrite_url === props.match.params.package_id;
          })
        : null;

    useEffect(() => {
        const date = Dates.ymd(filter.date) || Dates.ymd(new Date());
        dispatch(BookingAction.fetchPackagesByCategory(date, filter.category ?? PackageCategory.General)).then(() => {});
    }, [filter.date, filter.category]);

    if (!packages || packages.length === 0) {
        return <Loader />;
    }

    console.log(foundPackage);
    return (
        <div className={"PackageDetails w-full"}>
            {foundPackage && !isGiftCard(foundPackage) && !isThreeTwo(foundPackage) && !isYearly(foundPackage) && <PackageDetail packageDetail={foundPackage} />}

            {foundPackage &&
                isGiftCard(foundPackage) &&
                // (SELL_GIFTCARD_VOUCHERS ? <VoucherPackageDetail packageDetail={foundPackage} /> : <GiftCardPackageDetail packageDetail={foundPackage} />)}
                (SELL_GIFTCARD_VOUCHERS ? <GiftCardPackageDetailNew packageDetail={foundPackage} /> : <GiftCardPackageDetail packageDetail={foundPackage} />)}

            {foundPackage && isYearly(foundPackage) && foundPackage.rewrite_url == 'yearly' && <YearlyPackageDetail packageDetail={foundPackage} />}
            {foundPackage && isYearly(foundPackage) && foundPackage.rewrite_url == 'threetwo' && <ThreeTwoPackageDetail packageDetail={foundPackage} />}
        </div>
    );
};

export default withRouter(BookingPackage);
